import { render, staticRenderFns } from "./Effluents.vue?vue&type=template&id=027976ba&scoped=true"
import script from "./Effluents.vue?vue&type=script&lang=js"
export * from "./Effluents.vue?vue&type=script&lang=js"
import style0 from "./Effluents.vue?vue&type=style&index=0&id=027976ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027976ba",
  null
  
)

export default component.exports